/**
 * Format follower counts for display.
 * 0 → "0"
 * 500 → "500"
 * 1,200 → "1.2K"
 * 10,500 → "10.5K"
 * 100,000 → "100K"
 * 432,000 → "432K"
 * 1,600,000 → "1.6M"
 * 10,200,000 → "10.2M"
 */
export function formatFollowers(count) {
  if (!count || count === 0) return "0";
  if (count < 1000) return count.toString();
  if (count < 1000000) {
    const k = count / 1000;
    return k >= 100 ? `${Math.round(k)}K` : `${parseFloat(k.toFixed(1))}K`;
  }
  const m = count / 1000000;
  return m >= 100 ? `${Math.round(m)}M` : `${parseFloat(m.toFixed(1))}M`;
}
